import BrandPage from './brand';

export default BrandPage;
